define.alias("ember-composable-helpers/helpers/compact", "calendar/helpers/compact");